import { Injectable } from '@angular/core';
import { getCurrentUser, fetchAuthSession } from "aws-amplify/auth";
import { Hub } from "aws-amplify/utils";
import { BehaviorSubject, Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserGroupService {
  private userGroups = new BehaviorSubject<string[]>([]);
  userGroups$ = this.userGroups.asObservable();

  // Derived role-specific observables
  isAdmin$ = this.userGroups$.pipe(map(groups => groups.includes('admin')));
  isManager$ = this.userGroups$.pipe(map(groups => groups.includes('manager')));
  isValuationAdmin$ = this.userGroups$.pipe(map(groups => groups.includes('adminvaluation')));

  constructor() {

    Hub.listen('auth', (data) => {
      const { payload } = data;
      if (payload.event === 'signedIn') {
        this.refreshUserGroups();
      } else if (payload.event === 'signedOut') {
        this.userGroups.next([]);
      }
    });

    this.initUserGroups();

  }

  async initUserGroups(): Promise<void> {
    try {
      await getCurrentUser();
      const session = await fetchAuthSession();
      const cognitoGroups = session.tokens?.accessToken?.payload['cognito:groups'];
      const groups = Array.isArray(cognitoGroups) ? cognitoGroups as string[] : [];
      this.userGroups.next(groups);
    } catch (error) {
      console.error('Error getting user groups:', error);
      this.userGroups.next([]);
    }
  }

  // Other methods remain the same
  async isInGroup(group: string): Promise<boolean> {
    const groups = await this.userGroups$.pipe().toPromise();
    return groups?.includes(group) || false;
  }

  getUserGroups(): Observable<string[]> {
    return this.userGroups$;
  }

  async refreshUserGroups(): Promise<void> {
    await this.initUserGroups();
  }
}